import { useEffect } from 'react';
import { useStorageService } from '~/_shared/utils/storageService';
import { notNullOrUndefined } from '~/_shared/utils/typeGuards';
import { ModalType } from '~/modal/modalType.enum';
import { useModal } from '~/modal/useModal.hook';
import { useUserDataSelector } from '~/store/userData/userData.selectors';

const getOldSeenQuickstartKey = (userId: number) => `seenQuickstart|${userId}`;
const seenQuickstartKey = 'seenQuickstart';

export const useShowWelcomeModalOnFirstLogin = () => {
  const storageService = useStorageService();
  const { id: userId, previousLogin } = useUserDataSelector();
  const { openModal } = useModal(ModalType.Welcome);

  const oldKey = notNullOrUndefined(userId) && getOldSeenQuickstartKey(userId);
  const oldSeenQuickstart = oldKey && localStorage.getItem(oldKey);
  const newSeenQuickstart = !!storageService.getLocalStorageItem(seenQuickstartKey);
  const seenQuickstart = notNullOrUndefined(oldSeenQuickstart) || newSeenQuickstart;

  // TODO: 2026/05/01: Remove the old key compatibility code.
  useEffect(() => {
    if (oldSeenQuickstart && !newSeenQuickstart) {
      // Transfers the old key to the new key
      storageService.setLocalStorageItem(seenQuickstartKey, new Date().toISOString());
    }
  }, [newSeenQuickstart, oldSeenQuickstart, storageService]);

  useEffect(() => {
    if (!previousLogin && !seenQuickstart && userId) {
      storageService.setLocalStorageItem(seenQuickstartKey, new Date().toISOString());
      openModal();
    }
  }, [previousLogin, openModal, seenQuickstart, storageService, userId]);
};
